/**
 * Get API base URL. In production (custom domain), uses relative path.
 * Only uses REACT_APP_BACKEND_URL for preview/development environments.
 */
const rawUrl = process.env.REACT_APP_BACKEND_URL || '';

function getApiUrl() {
  if (typeof window === 'undefined') return rawUrl;
  const host = window.location.hostname;
  // If running on a custom domain (not preview/localhost), use relative paths
  if (host !== 'localhost' && !host.includes('preview.emergentagent.com')) {
    return '';
  }
  return rawUrl;
}

export const API_URL = getApiUrl();
